import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="#about">About Us</a>
        <span className="footer-divider">|</span>
        <a href="#contact">Contact Us</a>
      </div>
      <p>© 2026 Tekomania. All rights reserved.</p>
    </footer>
  );
}
